import React from 'react';
import Check from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import sanitizeHtml from 'sanitize-html';
import { StyledFeaturesDescriptionList } from './index.style';

const FeaturesDescriptionList = ({ featuresDescription }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  if (!featuresDescription?.length) return null;

  return (
    <StyledFeaturesDescriptionList>
      {featuresDescription.map((item) => {
        const text = item && item[language];

        return (
          <div className="features-description-item" key={item?.vi}>
            <Check
              fontSize="small"
              className={
                item?.advanced
                  ? 'check-icon coming-soon-text-advanced'
                  : 'check-icon'
              }
            />
            <span
              className={`feature-text${item?.advanced ? ' advanced' : ''}`}
            >
              <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(text, {
                    allowedTags: ['strong', 'p', 'span'],
                    allowedAttributes: { span: ['style'] },
                  }),
                }}
              />
              {item?.comingSoon && (
                <span className="coming-soon-title">({t('comingSoon')})</span>
              )}
            </span>
          </div>
        );
      })}
    </StyledFeaturesDescriptionList>
  );
};

export default FeaturesDescriptionList;
